@if (content()) {
  <div [ngClass]="'wrapper flex flex--row ' + content().subjectTaxonomyTags">
    <fcom-heading-tag [level]="headerLevel()" extraClasses="ps-small-b nordic-blue-900-text text-icon-primary title">
      {{ content().teaserTitle }}
    </fcom-heading-tag>
    <div class="nordic-blue-900-text text-icon-primary text font-body-medium">
      <div [innerHTML]="content().teaserText | finSafe: 'html'"></div>
      @if (content().target?.url && content().linkText) {
        <a
          [finLink]="content().target.url"
          class="flex flex--middle nordic-blue-900-text text-icon-primary no-underline pr-xxsmall-t underline-hover font-body-medium-bold"
        >
          {{ content().linkText }}
          <fcom-icon
            class="editorial-category-link-icon nordic-blue-900-text text-icon-primary icon-small"
            [name]="SvgLibraryIcon.ARROW_RIGHT"
          />
        </a>
      }
    </div>
  </div>
}
